<template>
  <div>
    <header class="py-3 mb-3">
      <div
        class="container-fluid d-flex align-items-center justify-content-between"
      >
        <div class="items-nav">
          <img
            src="../assets/logomarca-white.svg"
            alt="Logomarca Cogumelos Umami"
          />
          <img
            src="../assets/logotipo-white.svg"
            alt="Logotipo Cogumelos Umami"
          />
        </div>

        <div class="items-nav mr-2">
          <div
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <span class="first-name"> {{ user.name }}</span>
          </div>
          <div>
            <img
              v-if="user.image"
              :src="this.user.image"
              alt="mdo"
              width="50"
              height="50"
              class="rounded-circle"
            />
            <img
              v-else
              src="../assets/user.png"
              alt="mdo"
              width="50"
              height="50"
              class="rounded-circle"
            />
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { User } from '../services/Users';

export default {
  data() {
    return {
      user: {},
    };
  },
  created() {
    const userAux = this.$store.getters.getUser;
    User(userAux.id).then((res) => {
      this.user = res.data;
    });
    if (typeof this.user.name === 'string')
      this.user.name = this.user.name.split(' ');
  },
};
</script>

<style scoped>
header {
  background-color: #be8250;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  color: #fff;
}

.first-name {
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: 0.1em;
}

.second-name {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.185em;
}

.items-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
